import React, { useEffect, useState } from 'react'
import { useLoaderData } from 'react-router-dom';
import { updatePrivilege } from '../../adapters/users';
import useStore from '../../store/index';
import { showAlert } from '../../utils/alert';

export default function User() {
    const userData = useLoaderData();
    const [ tab, setTab ] = useState(0);
    const languages = useStore((state) => state.languages);


    const getLangName = () => {
        const lang = languages[userData.language]
        return lang.name
    }
   
    const updateUserPrivilege = async () => {
        try {
            await updatePrivilege(userData._id).then((res) => {
                if(res.status === 200) {
                    showAlert('Success','Successfully changed user privilege');
                }
            })
        } catch (e) {
            showAlert( 'error','Failed!','An error occured')
        }
    }
  return (
        <div className="w-full">
            <h4 className="text-xl font-fira font-semibold capitalize">User Profile</h4>
            <div className="mt-4 py-6 bg-gray-100 rounded-lg">
              <div className="flex gap-4 lg:justify-between justify-start flex-col lg:flex-row items-center mb-6 px-6">
                    <div className="flex gap-4 justify-start items-center">
                        <img src={userData.avatar} alt="avatar" className="h-32 w-32 rounded-full" />
                        <div>
                        <h4 className="font-semibold font-sm font-fira">{userData.name}</h4>
                        <div className="flex flex-col gap-0">
                            <a className="text-xs font-semibold text-blue-800 hover:text-blue-900" href={`mailto:${userData.mail}`}>{userData.email}</a>
                            <a className="text-xs font-semibold text-blue-800 hover:text-blue-900" href={`tel:${userData.profile.phone}`}>{userData.profile.phone}</a>
                        </div>
                        </div>
                    </div>
                    <button onClick={updateUserPrivilege} className="bg-blue-800 text-white hover:bg-blue-900 text-xs py-3 px-6 rounded-lg font-semibold">
                        {userData.role === 0 ? 'Grant Admin Privilege' : 'Revoke admin Privilege'}
                    </button>
                </div>
                <div className="tab bg-gray-200 cursor-pointer text-xs w-full py-3 flex justify-start gap-5 mb-6 px-6 items-center">
                  <h4 onClick={() => {
                      setTab(0);
                  }} className={`font-fira cursor-pointer font-semibold px-2 rounded-full py-1 ${tab === 0 ? 'text-white bg-blue-900' : 'text-gray-800 hover:bg-blue-800 hover:text-white'}`}>BASIC INFO</h4>
                  <h4 onClick={() => {
                      setTab(1);
                  }} className={`font-fira font-semibold px-2 rounded-full py-1 ${tab === 1 ? 'text-white bg-blue-900' : 'text-gray-800 hover:bg-blue-800 hover:text-white'}`}>APPLICATION INFO</h4>
                </div>

                {tab === 0 && <div className="bio-tab">
                    <h3 className="text-sm font-semibold font-fira ml-6 mb-2">Basic Infomation</h3>
                    <ul className="px-6">
                        <li className='py-3 border-b border-gray-500'>
                            <div className="flex justify-between items-center">
                            <h4 className="text-xs font-gray-600 font-semibold font-fira">First name</h4>
                            <h4 className="text-xs font-gray-800 font-semibold font-fira">{userData.profile.firstname}</h4>
                            </div>
                        </li>

                    <li className='py-3 border-b border-gray-500'>
                        <div className="flex justify-between items-center">
                            <h4 className="text-xs font-gray-600 font-semibold font-fira">Last name</h4>
                            <h4 className="text-xs font-gray-800 font-semibold font-fira">{userData.profile.lastname}</h4>
                        </div>
                    </li>

                    <li className='py-3 border-b border-gray-500'>
                        <div className="flex justify-between items-center">
                            <h4 className="text-xs font-gray-600 font-semibold font-fira">Other name</h4>
                            <h4 className="text-xs font-gray-800 font-semibold font-fira">{userData.profile.othername || 'Not Set!'}</h4>
                        </div>
                    </li>

                    <li className='py-3 border-b border-gray-500'>
                        <div className="flex justify-between items-center">
                            <h4 className="text-xs font-gray-600 font-semibold font-fira">Age</h4>
                            <h4 className="text-xs font-gray-800 font-semibold font-fira">{userData.profile.age} Years</h4>
                        </div>
                    </li>

                    <li className='py-3 border-b border-gray-500'>
                        <div className="flex justify-between items-center">
                            <h4 className="text-xs font-gray-600 font-semibold font-fira">Email</h4>
                            <a href={`mailto:${userData.email}`} className="text-xs font-blue-800 hover:text-blue-900 font-semibold font-fira">{userData.email}</a>
                        </div>
                    </li>

                    <li className='py-3 border-b border-gray-500'>
                        <div className="flex justify-between items-center">
                            <h4 className="text-xs font-gray-600 font-semibold font-fira">Level Of Education</h4>
                            <h4 className="text-xs font-gray-800 font-semibold font-fira">{userData.profile.education}</h4>
                        </div>
                    </li>

                    <li className='py-3 border-b border-gray-500'>
                        <div className="flex justify-between items-center">
                            <h4 className="text-xs font-gray-600 font-semibold font-fira">Ocupation</h4>
                            <h4 className="text-xs font-gray-800 font-semibold font-fira">{userData.profile.occupation}</h4>
                        </div>
                    </li>

                    <li className='py-3 border-b border-gray-500'>
                        <div className="flex justify-between items-center">
                            <h4 className="text-xs font-gray-600 font-semibold font-fira">Country</h4>
                            <h4 className="text-xs font-gray-800 font-semibold font-fira">{userData.profile.country}</h4>
                        </div>
                    </li>

                    <li className='py-3 border-b border-gray-500'>
                        <div className="flex justify-between items-center">
                            <h4 className="text-xs font-gray-600 font-semibold font-fira">State/Province</h4>
                            <h4 className="text-xs font-gray-800 font-semibold font-fira">{userData.profile.state}</h4>
                        </div>
                    </li>
                    
                    </ul>
                </div>}

                {tab === 1 && <div className="app-info-tab">
                  <h3 className="text-sm font-semibold font-fira ml-6 mb-3">Application Infomation</h3>
                  <ul className="px-6">
                      <li className='py-3 border-b border-gray-500'>
                          <div className="flex justify-between items-center">
                              <h4 className="text-xs font-gray-600 font-semibold font-fira">Role</h4>
                              <h4 className="text-xs font-gray-800 font-semibold font-fira">{userData.accountType === 1 ? 'User' : 'Medaitor'}</h4>
                          </div>
                      </li>

                      <li className='py-3 border-b border-gray-500'>
                          <div className="flex justify-between items-center">
                              <h4 className="text-xs font-gray-600 font-semibold font-fira">Case Resolutions</h4>
                              <h4 className="text-xs font-gray-800 font-semibold font-fira">{userData.cases}</h4>
                          </div>
                      </li>

                      <li className='py-3 border-b border-gray-500'>
                          <div className="flex justify-between items-center">
                              <h4 className="text-xs font-gray-600 font-semibold font-fira">Transactions</h4>
                              <h4 className="text-xs font-gray-800 font-semibold font-fira">{userData.transactions}</h4>
                          </div>
                      </li>

                      <li className='py-3 border-b border-gray-500'>
                          <div className="flex justify-between items-center">
                              <h4 className="text-xs font-gray-600 font-semibold font-fira">Language</h4>
                              <h4 className="text-xs font-gray-800 font-semibold font-fira">{getLangName()}</h4>
                          </div>
                      </li>

                  </ul>
                </div>}
                
            </div>
        </div>
  )
}
